<template>
  <b-tab
    id="tab1"
    title="ข้อมูลกลุ่ม"
  >
    <b-row>
      <b-col md="3">
        <b-form-group
          label="รหัส"
          label-for="complaintCode"
        >
          <b-form-input
            id="complaintCode"

            placeholder="กรุณากรอก รหัส"
          />
        </b-form-group>
      </b-col>
      <b-col md="9">
        <b-form-group
          label="หัวข้อกลุ่มดำเนินการ"
          label-for="complaintGroupTitle"
        >
          <b-form-input
            id="complaintGroupTitle"

            placeholder="กรุณากรอก หัวข้อกลุ่มดำเนินการ"
          />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          label="รายละเอียด"
          label-for="complaintGroupDetail"
        >
          <b-form-textarea
            id="complaintGroupDetail"

            placeholder="กรุณากรอก รายละเอียด"
            rows="12"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <common-table mode="List" />
      </b-col>

    </b-row>
  </b-tab>
</template>

<script>

import {
  BRow, BCol, BFormTextarea, BFormGroup, BFormInput, BTab, BTabs, BCard,
} from 'bootstrap-vue'
import CommonTable from '../../../table/vue-good-table/CommonTableLawGroup.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    CommonTable,
  },
}
</script>

<style>

</style>
